import type { ReactElement } from 'react';
import { cloneElement } from 'react';
import type { LayoutMeasure, TabNavItemProps } from '../TabNav.types';

export type TabNavClonedElement = ReactElement<
  TabNavItemProps | { readonly ref: React.Ref<unknown> }
>;

type GetTransformedChildren = (p: {
  readonly child: TabNavClonedElement;
  readonly index: number;
  readonly value: number;
  readonly onChange: (index: number, child: TabNavClonedElement) => void;
  readonly onChangeMeasures?: (m: LayoutMeasure, i: number) => void;
}) => TabNavClonedElement;

export const getTransformedChildren: GetTransformedChildren = ({
  child,
  index,
  value,
  onChangeMeasures,
  ...props
}) =>
  cloneElement(child, {
    index,
    onChangeMeasures,
    onPress() {
      props.onChange(index, child);
    },
    active: index === value,
    ...props,
  });
